<template>
  <div class="messagedetails">
    <div class="messagedetails-wrap">
      <!-- <div class="messagedetails-back" @click="goback">
        <img class="tip" src="../../assets/images/icon_back@2x.png" alt="">
        <a class="tip-back" href="#">返回</a>
      </div> -->
      
      <div class="container">
        <div class="messagedetails-title">
          <h1>系统消息</h1>
          <p>{{sendTime}}</p>
        </div>
        <div class="messagedetails-content">
          <p style="text-indent:2em;">{{content}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types';
import messageDetailsApi from '../../api/message';

export default {
  data () {
    return {
      content: '',
      sendTime: ''
    };
  },
  computed: {

    ...mapGetters({}),
    ...mapActions({
      getLoanAllData: types.GET_LOAN_ALL_DATA,
      signAture: types.SIGN_AGREEMENT,
      downContract: types.DOWN_AGREEMENT,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    ...mapMutations({
      setLoanAllData: types.SET_LOAN_ALL_DATA,
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE,
      setSigned: types.SET_SIGNED
    })
  },

  created () {

  },
  mounted () {
    this.getData();
    this.$route.query.msgRemindId;
  },
  methods: {
    goback () {
      this.$router.go(-1);
    },
    getData () {
      messageDetailsApi.msgDetails({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        msgRemindId: this.$route.query.msgRemindId

      }).then((res) => {
        if (res.code === 0) {
          this.content = res.result.content;
          this.sendTime = res.result.sendTime;
        } else {

        }
      }).catch((err) => {
        console.log('err', err);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.messagedetails {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 35px;
  padding-left: 40px;
  .messagedetails-back {
    .tip {
      width: 9px;
      height: 13px;
    }
    .tip-back{
      font-size: 18px;
      color: #ccc;
    }
  }
  .container {
    margin-top: 15px;
    padding-top: 30px;
    padding-bottom: 70px;
    background-color: #fff;
    .messagedetails-title {
      h1 {
        font-size: 20px;
        text-align: center;
      }
      p {
        font-size: 14px;
        text-align: center;
        padding-top: 30px;
        color: #333;
      }
    }
    .messagedetails-content {
      padding-top: 40px;
      p {
        text-align: center;
        font-size: 16px;
        padding: 15px 30px 0 30px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// messagedetails.vue?5313ccb2